module.exports = __webpack_public_path__ + "img/signup-within-7months.1f5c8ec.png";